<template>
<v-layout row wrap>
    <v-flex xs12 md3 class="subheading">
        <v-icon left>reply</v-icon>
        Ihre Antwort</v-flex>
    <v-flex xs12 md9>
     <v-textarea
        v-model="msgtext"
        label="Hier Ihre Antwort an den Kunden"
        auto-grow
        required
        outline
        counter="500"
    ></v-textarea>
    <div class="text-xs-center">
          <v-btn
            @click="zeigeKontakt()"
            color="accent"
            class="mx-auto"
          >Antworten</v-btn>
        </div>
    </v-flex>
{{ anfrage }}
</v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    msgtext: '',
    onboarding: 0
  }),
  props: ['anfrage'],

  methods: {
    fehlermeldenpost () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const daten = {
          text: this.msgtext
        }
        console.log(daten)
        axios
          .post('/api/v1/kontaktbetrieb', daten)
          .then((resp) => {
            // console.log(resp)

            this.fehlertext = ''

            this.$store.dispatch('responseMessage', {
              type: 'success',
              modal: 'true',
              title: 'Nachricht gesendet!',
              text: 'Vielen Dank!'
            })
            this.dialog = false
            // this.block = true
          })
          .catch((resp) => {
            // console.log('error: ')
            //   console.log(resp);
          })

        this.loading = false
      }
    },
    next (event) {
      this.onboarding = this.onboarding + 1 === this.length
          ? 0
          : this.onboarding + 1
      this.$emit('clicked', event)
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
          ? this.length - 1
          : this.onboarding - 1
    }
  }
}
</script>